import { render, staticRenderFns } from "./KInput.vue?vue&type=template&id=654e7e0a&scoped=true&"
import script from "./KInput.vue?vue&type=script&lang=js&"
export * from "./KInput.vue?vue&type=script&lang=js&"
import style0 from "./KInput.vue?vue&type=style&index=0&id=654e7e0a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654e7e0a",
  null
  
)

export default component.exports